/**
 * Upload contract of `POST /v1/sync/upload` (docs/09 §2.2) and client schema versioning
 * (docs/08 §12). Shared by the API (validation) and the clients (connector).
 */
/**
 * Version of the client schema this build of the clients speaks (docs/08 §12).
 * 2: full schema of docs/08 (user preferences, views, highlights, rituals, custom fields, assets).
 */
export const CLIENT_SCHEMA_VERSION = 2;
/**
 * Oldest client schema the API still accepts; older clients get `426 client_outdated` (S9).
 * Stays at 1: the full schema only adds tables and columns, so a client of F0 keeps working
 * (expand/contract, docs/08 §12). It only rises when something the clients used is retired.
 */
export const MIN_CLIENT_SCHEMA = 1;
/** Headers every client request to `/v1/*` carries (docs/09 §1). */
export const CLIENT_HEADERS = {
    platform: 'X-Client-Platform',
    version: 'X-Client-Version',
    schema: 'X-Client-Schema',
};
/** Maximum operations per batch accepted by the API (the SDK batches by local transaction). */
export const MAX_OPERATIONS_PER_BATCH = 1000;
//# sourceMappingURL=contract.js.map